import script from "./BeneficiaryCell.vue?vue&type=script&setup=true&lang=js"
export * from "./BeneficiaryCell.vue?vue&type=script&setup=true&lang=js"

import "./BeneficiaryCell.vue?vue&type=style&index=0&id=01185ac6&lang=scss"

const __exports__ = script;

export default __exports__